import React, { forwardRef, memo } from 'react'

const BurstIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="36.4"
      height="36.4"
      viewBox="0 0 52 52"
      fill="none"
      {...props}>
      <path
        d="m20.242 31.507-11.19-4.123a2.42 2.42 0 0 1-1.763-2.385c0-.9.471-1.737 1.263-2.122l11.69-4.123 4.123-11.19A2.422 2.422 0 0 1 25.875 8c.476 0 .939.142 1.321.41.382.27.67.648.858 1.057l4.123 11.69 11.19 4.124c.81.298 1.389 1.06 1.389 1.993 0 .934-.579 1.695-1.389 1.993l-11.19 4.124-4.123 11.19a2.422 2.422 0 0 1-3.65 1.057 2.42 2.42 0 0 1-1.057-1.057l-4.123-11.19Z"
        stroke="#78BE20"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
)

BurstIcon.displayName = 'BurstIcon'

export default memo(BurstIcon)
